// Mirrors spidra-backend/config/monitorLimits.ts: how many monitors each plan can have and how often they can check.
// The API enforces it; the Billing page uses it to compare plans.
export const MONITOR_LIMITS: Record<string, { minIntervalMinutes: number; maxMonitors: number }> = {
  Free: { minIntervalMinutes: 1440, maxMonitors: 2 },
  Starter: { minIntervalMinutes: 60, maxMonitors: 10 },
  Builder: { minIntervalMinutes: 15, maxMonitors: 50 },
  Pro: { minIntervalMinutes: 5, maxMonitors: 200 },
  Enterprise: { minIntervalMinutes: 5, maxMonitors: 1000 },
};

export const monitorLimitsFor = (planName?: string | null) =>
  (planName && MONITOR_LIMITS[planName]) || MONITOR_LIMITS.Free;

/** "2 monitors, checked daily", "10 monitors, checked as often as every hour". */
export function monitorLimitLine(planName?: string | null): string {
  const { maxMonitors, minIntervalMinutes: m } = monitorLimitsFor(planName);
  const count = `${maxMonitors.toLocaleString("en-US")} monitor${maxMonitors === 1 ? "" : "s"}`;
  if (m >= 1440) return `${count}, checked daily`;
  const every =
    m === 60 ? "every hour" : m % 60 === 0 ? `every ${m / 60} hours` : `every ${m} minutes`;
  return `${count}, checked as often as ${every}`;
}

/** "2, daily", "10, hourly", "50, every 15 min": the short form for the plan cards. */
export function monitorLimitShort(planName?: string | null): string {
  const { maxMonitors, minIntervalMinutes: m } = monitorLimitsFor(planName);
  const every =
    m >= 1440
      ? "daily"
      : m === 60
        ? "hourly"
        : m % 60 === 0
          ? `every ${m / 60} hours`
          : `every ${m} min`;
  return `${maxMonitors.toLocaleString("en-US")}, ${every}`;
}
